import { capitalizeString, formatDate, formatNameLastFirst } from '@strata/helper-functions';
import { IssueDetail } from '@strata/react-status-icons';
import { OpportunityStatusIndicator } from '@strata/react-status-indicators';

const FixableIssues = [
    IssueDetail.IssueTypes.INVALID_PRESCRIBER_NPI,
    IssueDetail.IssueTypes.INVALID_DAYS_SUPPLY,
    IssueDetail.IssueTypes.MISSING_PLACE_OF_SERVICE,
    IssueDetail.IssueTypes.INVALID_MEMBER_ADDRESS,
    IssueDetail.IssueTypes.WAIT_FOR_CLAIM,
];

export const determineStatus = (issues) => {
    if (issues.includes(IssueDetail.IssueTypes.AUTH_EXPIRED))
        return OpportunityStatusIndicator.Statuses.CLOSED;
    if (issues.includes(IssueDetail.IssueTypes.WAIT_FOR_CLAIM))
        return OpportunityStatusIndicator.Statuses.AWAITING_CLAIM;
    if (issues.includes(IssueDetail.IssueTypes.WAIT_FOR_AUTH))
        return OpportunityStatusIndicator.Statuses.AWAITING_AUTH;
    return OpportunityStatusIndicator.Statuses.INCOMPLETE;
};

export const canFix = (issues) => (issues ?? []).some((issue) => FixableIssues.includes(issue));

export const mapOpportunityDetails = ({ opportunity, issues }) => ({
    benefit: opportunity.benefit,
    canFix: canFix(issues),
    isBrand: opportunity.is_brand,
    issues,
    memberId: opportunity.member_id,
    patientDob: opportunity.patient_dob,
    patientFirstName: opportunity.patient_first_name,
    patientLastName: opportunity.patient_last_name,
    payerId: opportunity.payer_id,
    placeOfService: opportunity.place_of_service,
    prescriberNpi: opportunity.prescriber_npi,
    productQty: opportunity.product_qty,
    productServiceId: opportunity.product_service_id,
    productServiceOid: opportunity.product_service_oid,
    receivedTime: opportunity.received_time,
    referralId: opportunity.referral_id,
    segmentId: opportunity.segment_id,
    status: determineStatus(issues),
    treatmentId: opportunity.treatment_id,
});

export const mapOpportunityRow = (opportunity) => ({
    authId: opportunity.auth_id,
    benefit: opportunity.benefit,
    canFix: canFix(opportunity.issues),
    isBrand: opportunity.is_brand,
    issues: opportunity.issues,
    memberId: opportunity.member_id,
    patientDOB: formatDate(opportunity.patient_dob),
    patientFirstName: opportunity.patient_first_name,
    patientLastName: opportunity.patient_last_name,
    patientName: formatNameLastFirst(opportunity.patient_last_name, opportunity.patient_first_name),
    payerId: opportunity.payer_id,
    productServiceName: opportunity.product_service_name,
    productServiceOid: opportunity.product_service_oid,
    receivedDate: opportunity.received_date,
    referralId: opportunity.referral_id,
    segmentId: opportunity.segment_id,
    segmentName: opportunity.segment_name,
    status: determineStatus(opportunity.issues),
    treatmentId: opportunity.treatment_id,
});

export const mapOpportunitySummary = ({ opportunity, issues }) => ({
    authId: opportunity.auth_id,
    benefitType: capitalizeString(opportunity.benefit),
    opportunityStatus: determineStatus(issues),
    receivedTime: opportunity.received_time,
    referralId: opportunity.referral_id,
});
